export default "__VITE_ASSET__2ee6bdba__"